import React, { useEffect, useState, useCallback } from 'react';
// import { Link } from 'react-router-dom';
import { SearchBar } from 'antd-mobile';
import Connect from '@store/connect';
// import PropTypes from 'prop-types';
import InfoCard from '@components/info-card';
import dayjs from 'dayjs';
import axios from 'axios';
import InfiniteScroll from 'react-infinite-scroll-component';
import { UserContactOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import './index.scss';

const fetchMoreData = async (pageNo, taskName) => {
    let url = `/api/task/fe-list/${pageNo}`;
    if (taskName) {
        url += `?taskName=${taskName}`;
    }
    const res = await axios({
        url,
        method: 'get',
    });
    return res.data || { data: [], total: 0, status: false };
};

const Home = () => {
    const [data, setData] = useState([]);
    const [taskName, setTaskName] = useState('');
    const [dataLength, setDataLength] = useState(0);
    const [pageNo, setPageNo] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const navigate = useNavigate();
    const fetchData = useCallback(async () => {
        const newPageNo = pageNo + 1;
        setPageNo(newPageNo);
        const newData = await fetchMoreData(newPageNo, taskName);
        const { data, total } = newData;

        setData(prevData => [...prevData, ...(data || [])]);
        setDataLength(prevLength => prevLength + data.length);
        if (newPageNo * 10 >= total) {
            setHasMore(false);
        }
    }, [pageNo, setHasMore, taskName]);

    const initData = useCallback(
        async taskName => {
            const newData = await fetchMoreData(1, taskName);
            const { data, total } = newData;
            setPageNo(1);
            setData(data);
            // 初始化就是10
            setDataLength(data.length);
            if (total > 10) {
                setHasMore(true);
            } else {
                setHasMore(false);
            }
        },
        [taskName, setData, setDataLength, setHasMore, setPageNo]
    );

    const gotoDetail = useCallback(id => {
        navigate(`/detail?id=${id}`, { state: { id } });
    }, []);

    useEffect(() => {
        initData();
    }, []);

    return (
      <div className="main-content">
        <SearchBar
                placeholder="请输入项目名称搜索"
                style={{ width: '100%' }}
                onSearch={taskName => {
                    setPageNo(1);
                    setTaskName(taskName);
                    initData(taskName);
                }}
            />
        <InfiniteScroll
                dataLength={dataLength}
                next={fetchData}
                hasMore={hasMore}
                loader={<h4>加载中...</h4>}
            >
          {data.map((item, index) => (
            <InfoCard
                        key={`${index}`}
                        id={item.id}
                        title={`项目编码:${item.task_id}`}
                        sub_title={`项目名称:${item.task_name}`}
                        description={`报名时间:${dayjs(
                            item.sign_start_time
                        ).format('YYYY-MM-DD')}~${dayjs(
                            item.sign_end_time
                        ).format('YYYY-MM-DD')}`}
                        callback={gotoDetail}
                    />
                ))}
        </InfiniteScroll>
        <div
                className="me"
                onClick={() => {
                    navigate(`/self-info`, { state: {} });
                }}
            >
          <UserContactOutline />
        </div>
      </div>
    );
};

Home.propTypes = {};

const mapStateToProps = () => {};

export default Connect(mapStateToProps)(Home);
